import {signInWithEmailAndPassword , onAuthStateChanged} from 'firebase/auth'
import AuthStateChange from './authStateChange';

const LoginFunction = (
  auth,
  redirect,
  setIsLogut,
  setIfAccExists,
  setInvalidCredentials,
  setAuthenticated,
  setUserExists,
  email,
  password
) => {
  setIsLogut(false);

  setIfAccExists(false);

  setInvalidCredentials(false);

  signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;

      setAuthenticated(true);

      redirect("/home");

      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("userExists", "true");

      //function imported for user state management
      AuthStateChange(auth,setAuthenticated,setUserExists);

      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;

      setInvalidCredentials(true);

      setAuthenticated(false);

      localStorage.removeItem("isAutheticated");
      localStorage.removeItem("userExists");
    });
};

export default LoginFunction;
